import styled from 'styled-components';
import { useGetProductsQuery } from '../../../../../hooks/api/product/queries/useGetProducts.query';
import { IProduct } from '../../../../../interfaces/Product.interfaces';
import { ProductHorizontalListDetailViewGroup } from '../../../listView/ProductHorizontalListDetailView/ProductHorizontalListDetailViewGroup';
import { SectionTitle } from './SectionTitle';

interface ProductMorePluvaProductSectionProps {
  product: IProduct;
}

export const ProductMorePluvaProductSection = ({ product }: ProductMorePluvaProductSectionProps) => {
  const { data: filteredPluvaProducts } = useGetProductsQuery({
    searchParam: {
      category: 'PLUVA',
      status: 'ONSALE',
      count: 5,
    },
    options: {
      select: (latestPluvaProducts) => {
        return latestPluvaProducts.filter((latestPluvaProduct) => latestPluvaProduct.id !== product?.id);
      },
    },
  });

  if (filteredPluvaProducts && filteredPluvaProducts.length >= 3) {
    return (
      <Container>
        <SectionTitle>{'직접 매입하고 보증하는 플루바 매물'}</SectionTitle>
        <ProductHorizontalListDetailViewGroup pageType={'pdp'} category={'pluva'} products={filteredPluvaProducts} />
      </Container>
    );
  }

  return <></>;
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;

  padding: 32px var(--radius-large, 16px);
  gap: var(--radius-large, 16px);
`;
